<template>
    <section
        class="section-how-it-works bg-black-700 full-width min-h-screen flex flex-col relative">
        <!--Image Background-->
        <background-image
            :src="sectionHowItWorks.src"
            :srcset="sectionHowItWorks.imgSrcSet" />

        <!--Content Layout in a Container-->
        <div
            class="z-10 my-24 flex flex-col tablet:flex-row tablet:justify-between">
            <!--Content Block  -->
            <div class="section-text flex flex-col items-start ml-16 mb-16 desktop:ml-35 hd:mt-24">
                <!--Content Text Component-->
                <content-text>
                    <template #title-text>
                        <h2 class="font-light">
                            {{ sectionHowItWorks.title }}
                        </h2>
                    </template>
                    <template #subtitle-text>
                        <h2 class="font-bold">
                            {{ sectionHowItWorks.subtitle }}
                        </h2>
                    </template>
                </content-text>
            </div>

            <!-- How It Work Steps Div -->
            <div
                class="steps-container ml-16 mr-16 desktop:mr-35 hd:mt-24">
                <!-- Step Div -->
                <div
                    v-for="(step, index) in sectionHowItWorks.steps"
                    :key="index"
                    class="step flex max-w-lg mb-6">
                    <!-- Icon Div -->
                    <div
                        v-if="step.icon"
                        class="icons flex flex-col align-center text-white">
                        <svg-icon
                            :icon="step.icon"
                            class="h-12 w-12 text-white" />
                        <svg-icon
                            v-if="shouldShowVertialArrowForStep(index)"
                            icon="arrowVertical"
                            class="arrow text-gold-500 h-8 mt-4 transition-all duration-200"
                        />
                    </div>
                    <!-- Content Div -->
                    <div
                        v-if="step.title || step.text"
                        class="content flex flex-col uppercase tracking-wide ml-8">
                        <h3
                            v-if="step.title"
                            class="text-xl mb-3 text-white"
                            v-html="step.title" />
                        <p
                            v-if="step.text"
                            class="text-xs text-gray-450"
                            :class="{'highlighted': step.highlighted }"
                            v-html="step.text" />
                    </div>

                    <div
                        v-if="step.cta"
                        class="cta flex flex-row items-baseline">
                        <svg-icon icon="arrowHorizontalLong" />
                        <flat-button
                            :url="step.cta.route ? route(step.cta.route) : step.cta.url"
                            :text="step.cta.text"
                            :full-redirect="true"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ContentText from '@web/components/ContentText';
import BackgroundImage from '@web/components/BackgroundImage';
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { isEmpty, get } from 'lodash';
import FlatButton from '@whisper/components/buttons/FlatButton';

export default {
  components: {
    FlatButton,
    SvgIcon,
    ContentText,
    BackgroundImage,
  },
  props: {
    sectionHowItWorks: {
      type: Object,
      required: true,
    },
  },
  methods: {
    shouldShowVertialArrowForStep(currentIndex) {
      return currentIndex !== this.sectionHowItWorks.steps.length - 1 // don't show if it's the last step
                && isEmpty(get(this.sectionHowItWorks.steps[currentIndex + 1], 'cta')); // don't show if the next step is a CTA
    },
  },
};
</script>

<style scoped>

</style>
